/**
 * RESSONÂNCIA CURATIVA — DIAPASÃO 256Hz PRODUCT PAGE
 * diapasao-page.js
 * v2.0 — Correções:
 * - FIX 2: Lógica bidirecional cards de oferta ↔ checkbox
 * - FIX 3: Preço dinâmico baseado na oferta selecionada
 */

(function () {
  'use strict';

  /* ══════════════════════════════════════════════
     1. STICKY HEADER — aparece após 300px de scroll
  ══════════════════════════════════════════════ */
  function initStickyHeader() {
    var header = document.getElementById('dp-sticky-header');
    if (!header) return;
    var threshold = 300;
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          if (window.scrollY > threshold) {
            header.classList.add('is-visible');
          } else {
            header.classList.remove('is-visible');
          }
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ══════════════════════════════════════════════
     2. VSL PLAYER — thumbnail click para mostrar vídeo
  ══════════════════════════════════════════════ */
  function initVSL() {
    var placeholder    = document.getElementById('dp-vsl-placeholder');
    var playBtn        = document.getElementById('dp-play-btn');
    var thumbnail      = placeholder && placeholder.querySelector('.dp-vsl__thumbnail');
    var videoContainer = document.getElementById('dp-video-container');
    var progressFill   = placeholder && placeholder.querySelector('.dp-vsl__progress-fill');

    if (!thumbnail || !videoContainer) return;

    function showVideo() {
      thumbnail.style.display = 'none';
      videoContainer.style.display = 'block';

      var iframe = videoContainer.querySelector('iframe');
      if (iframe) {
        var src = iframe.src;
        if (src.includes('vimeo.com') && !src.includes('autoplay')) {
          iframe.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
        }
        if (src.includes('youtube.com') && !src.includes('autoplay')) {
          iframe.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
        }
      }

      if (progressFill) {
        var progress = 0;
        var interval = setInterval(function () {
          progress += 0.5;
          if (progress >= 100) { clearInterval(interval); return; }
          progressFill.style.width = progress + '%';
        }, 2400);
      }

      placeholder.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    thumbnail.addEventListener('click', showVideo);
    if (playBtn) playBtn.addEventListener('click', showVideo);
  }

  /* ══════════════════════════════════════════════
     3. COUNTDOWN — persiste entre sessões
  ══════════════════════════════════════════════ */
  function initCountdown() {
    var hEl = document.getElementById('dp-h');
    var mEl = document.getElementById('dp-m');
    var sEl = document.getElementById('dp-s');
    if (!hEl || !mEl || !sEl) return;

    var KEY = 'dp_countdown_v1';
    var DURATION_MS = 52 * 60 * 1000;
    var now = Date.now();
    var stored = parseInt(localStorage.getItem(KEY), 10);
    var endTime = stored && stored > now ? stored : now + DURATION_MS;
    localStorage.setItem(KEY, endTime);

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var diff = Math.max(0, endTime - Date.now());
      if (diff === 0) {
        endTime = Date.now() + DURATION_MS;
        localStorage.setItem(KEY, endTime);
        return;
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      hEl.textContent = pad(h);
      mEl.textContent = pad(m);
      sEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ══════════════════════════════════════════════
     4. VIEWER COUNT — contador dinâmico
  ══════════════════════════════════════════════ */
  function initViewerCount() {
    var el = document.getElementById('dp-viewer-count');
    if (!el) return;
    var base = 170 + Math.floor(Math.random() * 50);
    el.textContent = base;
    setInterval(function () {
      base += Math.floor(Math.random() * 7) - 3;
      base = Math.max(140, Math.min(280, base));
      el.textContent = base;
    }, 8000);
  }

  /* ══════════════════════════════════════════════
     5. FAQ ACCORDION
  ══════════════════════════════════════════════ */
  function initFAQ() {
    var list = document.getElementById('dp-faq-list');
    if (!list) return;
    var buttons = list.querySelectorAll('.dp-faq-item__q');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        buttons.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var a = b.nextElementSibling;
          if (a) a.classList.remove('is-open');
        });
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          var ans = btn.nextElementSibling;
          if (ans) ans.classList.add('is-open');
        }
      });
    });
  }

  /* ══════════════════════════════════════════════
     6. BUY BUTTON — Lógica bidirecional ofertas/checkbox
     FIX 2: Card ↔ Checkbox sincronizados
     FIX 3: Preços dinâmicos PIX + cartão
  ══════════════════════════════════════════════ */
  function initBuyButton() {
    var buyForm    = document.getElementById('dp-buy-form');
    var buyBtn     = document.getElementById('dp-buy-btn');
    var bumpCheck  = document.getElementById('dp-bump-check');
    var offerBasic = document.getElementById('dp-offer-basic');
    var offerBundle= document.getElementById('dp-offer-bundle');

    if (!buyForm || !buyBtn) return;

    /* Dados de preço por oferta */
    var PRICES = {
      basic: {
        pix:      'R$249,90',
        shipping: '+ Frete R$30 mínimo',
        card:     'no cartão: 10x de R$28,54',
        btnText:  'GARANTIR MEU DIAPASÃO — R$249,90'
      },
      bundle: {
        pix:      'R$289,90',
        shipping: '✦ Frete GRÁTIS incluído',
        card:     'no cartão: 10x de R$33,11',
        btnText:  'QUERO O KIT COMPLETO — R$289,90'
      }
    };

    /* Oferta selecionada atual — bundle é o default */
    var currentOffer = 'bundle';

    /* Atualiza toda a UI conforme oferta escolhida */
    function setOffer(offer) {
      currentOffer = offer;

      /* Cards visuais */
      if (offerBasic)  offerBasic.classList.toggle('is-selected',  offer === 'basic');
      if (offerBundle) offerBundle.classList.toggle('is-selected', offer === 'bundle');

      /* Sincroniza o checkbox (sem disparar o evento change para evitar loop) */
      if (bumpCheck) {
        bumpCheck.checked = (offer === 'bundle');
      }

      /* Atualiza bloco de preço */
      var p = PRICES[offer];
      var pixEl  = document.getElementById('dp-price-pix');
      var shipEl = document.getElementById('dp-price-shipping');
      var cardEl = document.getElementById('dp-price-card');
      if (pixEl)  pixEl.textContent  = p.pix;
      if (shipEl) shipEl.textContent = p.shipping;
      if (cardEl) cardEl.textContent = p.card;

      /* Atualiza texto do botão */
      var btnTextEl = buyBtn.querySelector('.dp-btn-buy__text');
      if (btnTextEl) btnTextEl.textContent = p.btnText;

      /* Atualiza ordem bump visual */
      var bumpContent = document.querySelector('.dp-order-bump__content');
      if (bumpContent) {
        bumpContent.style.opacity = offer === 'bundle' ? '1' : '0.6';
      }
    }

    /* ── Listeners dos cards ── */
    if (offerBasic) {
      offerBasic.addEventListener('click', function () {
        setOffer('basic');
      });
    }
    if (offerBundle) {
      offerBundle.addEventListener('click', function () {
        setOffer('bundle');
      });
    }

    /* ── Listener do checkbox (bidirecional) ── */
    if (bumpCheck) {
      bumpCheck.addEventListener('change', function () {
        /* Quando o utilizador clica diretamente na checkbox */
        setOffer(this.checked ? 'bundle' : 'basic');
      });
    }

    /* Aplica estado inicial = bundle */
    setOffer('bundle');

    /* ── Submit do formulário ── */
    buyForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var textEl      = buyBtn.querySelector('.dp-btn-buy__text') || buyBtn;
      var originalText = textEl.textContent;

      textEl.textContent = 'A processar...';
      buyBtn.classList.add('is-loading');
      buyBtn.disabled = true;

      var mainId   = buyForm.getAttribute('data-main-id');
      var bundleId = buyForm.getAttribute('data-bundle-id');
      var idToAdd  = currentOffer === 'bundle' ? bundleId : mainId;

      if (!idToAdd) {
        alert('Erro: Produto não encontrado. Verifique se os handles estão corretos no Shopify.');
        textEl.textContent = originalText;
        buyBtn.classList.remove('is-loading');
        buyBtn.disabled = false;
        return;
      }

      var cartUrl = (window.Shopify && window.Shopify.routes)
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';

      fetch(cartUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(idToAdd, 10), quantity: 1 }] })
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Erro na requisição: ' + response.status);
        return response.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (error) {
        console.error('Erro ao adicionar ao carrinho:', error);
        alert('Ocorreu um erro ao processar. Por favor, tente novamente.');
        textEl.textContent = originalText;
        buyBtn.classList.remove('is-loading');
        buyBtn.disabled = false;
      });
    });
  }

  /* ══════════════════════════════════════════════
     7. SCROLL REVEAL — animações ao entrar na tela
  ══════════════════════════════════════════════ */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;

    var targets = document.querySelectorAll(
      '.dp-symptom-card, .dp-testimonial-card, .dp-compare__col, ' +
      '.dp-howto__step, .dp-testimonial-featured, .dp-guarantee__card'
    );

    targets.forEach(function (el, i) {
      el.style.opacity   = '0';
      el.style.transform = 'translateY(22px)';
      el.style.transition = 'opacity 0.5s ease ' + (i % 4) * 0.08 + 's, transform 0.5s ease ' + (i % 4) * 0.08 + 's';
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity   = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    targets.forEach(function (el) { io.observe(el); });
  }

  /* ══════════════════════════════════════════════
     8. SOCIAL PROOF POPUP
  ══════════════════════════════════════════════ */
  function initSocialProofPopup() {
    var proofs = [
      { name: 'Beatriz H.',   city: 'SP', action: 'acabou de comprar', icon: '🛒' },
      { name: 'Renata M.',    city: 'MG', action: 'adicionou ao carrinho', icon: '🛒' },
      { name: 'Cláudia S.',   city: 'PR', action: 'acabou de comprar + guia', icon: '✓' },
      { name: 'Patricia L.',  city: 'RS', action: 'está comprando agora', icon: '⚡' },
      { name: 'Fernanda A.',  city: 'SC', action: 'acabou de comprar', icon: '🛒' },
      { name: 'Marina C.',    city: 'RJ', action: 'está vendo esta página', icon: '👁' },
    ];
    var idx = 0;

    var popup = document.createElement('div');
    popup.id = 'dp-sp-popup';
    popup.style.cssText = [
      'position:fixed', 'bottom:24px', 'left:20px',
      'background:#fff', 'border-radius:10px', 'padding:14px 16px',
      'box-shadow:0 8px 32px rgba(44,24,16,0.18)', 'max-width:300px',
      'z-index:9999', 'font-family:Lato,sans-serif',
      'border-left:4px solid #8B4513', 'display:none', 'transition:opacity 0.3s',
    ].join(';');

    document.head.insertAdjacentHTML('beforeend',
      '<style>@keyframes dpSlide{from{opacity:0;transform:translateX(-18px)}to{opacity:1;transform:translateX(0)}}</style>'
    );
    document.body.appendChild(popup);

    function show() {
      var p = proofs[idx % proofs.length];
      popup.innerHTML = [
        '<div style="display:flex;align-items:center;gap:10px">',
          '<div style="width:34px;height:34px;border-radius:50%;background:#8B4513;color:#FAF7F2;display:flex;align-items:center;justify-content:center;font-size:14px;flex-shrink:0">' + p.name[0] + '</div>',
          '<div style="flex:1">',
            '<div style="font-size:12px;font-weight:700;color:#2C1810">' + p.name + ' · ' + p.city + '</div>',
            '<div style="font-size:12px;color:#4A413C">' + p.icon + ' ' + p.action + '</div>',
            '<div style="font-size:11px;color:#D4A017;margin-top:2px">Ressonância Curativa 256Hz</div>',
          '</div>',
          '<button onclick="this.parentElement.parentElement.style.display=\'none\'" style="background:none;border:none;cursor:pointer;color:rgba(61,53,48,0.4);font-size:18px;padding:0;line-height:1;flex-shrink:0">×</button>',
        '</div>',
      ].join('');

      popup.style.display = 'block';
      popup.style.animation = 'dpSlide 0.4s ease';

      setTimeout(function () {
        popup.style.opacity = '0';
        setTimeout(function () {
          popup.style.display = 'none';
          popup.style.opacity = '1';
        }, 350);
      }, 5000);

      idx++;
    }

    setTimeout(function () {
      show();
      setInterval(show, 28000);
    }, 12000);
  }

  /* ══════════════════════════════════════════════
      9. STICKY BUY BAR — mobile only
   ══════════════════════════════════════════════ */
function initMobileStickyBuy() {
  // Mantém a regra de só aparecer no mobile
  if (window.innerWidth > 768) return;
  var buySection = document.getElementById('dp-buy-section');
  if (!buySection) return;

  var bar = document.createElement('div');
  bar.id = 'dp-mobile-buy-bar';
  bar.innerHTML = [
    '<div style="display:flex;align-items:center;justify-content:space-between;gap:8px">', // Gap mínimo para evitar empurrões
      
      // COLUNA DA ESQUERDA (Diapasão + Garantia)
      '<div style="text-align:left;line-height:1.5;flex-grow:1;">',
        '<div style="font-family:\'Lato\',sans;font-size:15px;font-weight:700;color:#FAF7F2;letter-spacing:0.04em;display:block">Diapasão</div>',
        '<div style="font-family:\'Lato\',sans;font-size:15px;font-weight:700;color:#FAF7F2;letter-spacing:0.04em;margin-bottom:2px">256Hz</div>',
        '<div style="font-size:10px;color:rgba(250,247,242,0.6)">Garantia 30 dias</div>',
      '</div>',
      
      // COLUNA CENTRAL (Estoque Limitado)
      '<div style="text-align:center;line-height:1.5;padding:0 8px;flex-grow:0;flex-shrink:0;">',
        '<div style="font-size:15px;font-weight:700;color:#D8A561;letter-spacing:0.02em;white-space:nowrap">Estoque</div>', // Cor dourada similar à imagem
        '<div style="font-size:15px;font-weight:700;color:#D8A561;letter-spacing:0.02em;white-space:nowrap">Limitado</div>', // Cor dourada similar à imagem
      '</div>',
      
      // COLUNA DA DIREITA (Botão CTA)
      '<div style="flex-grow:0;flex-shrink:0;">',
        '<a href="#dp-buy-section" id="dp-mobile-cta" style="background:#8B4513;color:#FAF7F2;text-decoration:none;border-radius:8px;padding:10px 14px;font-size:15px;font-weight:700;letter-spacing:0.02em;white-space:nowrap;display:inline-block">Confira a Disponibilidade</a>',
      '</div>',
    '</div>',
  ].join('');
  
  // Estilos da barra externa (fundo e borda superior)
  bar.style.cssText = [
    'position:fixed', 'bottom:0', 'left:0', 'right:0',
    'background:#1A0F0A', 'padding:15px 15px', 'z-index:199', // Fundo mais escuro, padding lateral
    'border-top:2px solid #8B4513', 'box-shadow:0 -4px 20px rgba(0,0,0,0.3)',
    'transform:translateY(100%)', 'transition:transform 0.35s cubic-bezier(.4,0,.2,1)',
    'display:none',
  ].join(';');

  document.body.appendChild(bar);
  bar.style.display = 'block';

  // Lógica do IntersectionObserver (mantida)
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      bar.style.transform = entry.isIntersecting
        ? 'translateY(100%)'
        : 'translateY(0)';
    });
  }, { threshold: 0 });

  io.observe(buySection);
}

  /* ══════════════════════════════════════════════
     10. SMOOTH SCROLL — links âncora
  ══════════════════════════════════════════════ */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        var offset = 70;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* ══════════════════════════════════════════════
     11. WAVE ANIMATION — SVG seção científica
  ══════════════════════════════════════════════ */
  function initWaveAnimation() {
    var svg = document.querySelector('.dp-science__wave-svg');
    if (!svg) return;
    var paths = svg.querySelectorAll('path');
    paths.forEach(function (path, i) {
      path.style.animation = 'dpWave ' + (2.5 + i * 0.5) + 's ease-in-out infinite ' + (i * 0.3) + 's';
    });
    document.head.insertAdjacentHTML('beforeend',
      '<style>@keyframes dpWave{0%,100%{opacity:0.4}50%{opacity:1}}</style>'
    );
  }

  /* ══════════════════════════════════════════════
     12. SCROLL TRACKING — eventos para Meta Pixel
  ══════════════════════════════════════════════ */
  function initScrollTracking() {
    var sections = {
      'dp-buy-section': 'ViewContent_BuySection',
      'dp-vsl-wrap':    'ViewContent_VSL',
    };

    if (!('IntersectionObserver' in window)) return;

    Object.keys(sections).forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var fired = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !fired) {
            fired = true;
            if (typeof fbq === 'function') { fbq('trackCustom', sections[id]); }
            if (typeof gtag === 'function') { gtag('event', sections[id]); }
          }
        });
      }, { threshold: 0.3 });
      io.observe(el);
    });
  }

  /* ══════════════════════════════════════════════
     INIT
  ══════════════════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    initStickyHeader();
    initVSL();
    initCountdown();
    initViewerCount();
    initFAQ();
    initBuyButton();
    initScrollReveal();
    initSocialProofPopup();
    initMobileStickyBuy();
    initSmoothScroll();
    initWaveAnimation();
    initScrollTracking();
  });

})();

